import { addMessages } from '@hana/i18n';

// Chuỗi còn lại của Kit (Tích hợp · Website · Nhật ký) — EN-2.
addMessages('vi', {
  'kit.x.chuaCo': 'Chưa có',
  'kit.x.taiKhoanM365': 'Tài khoản M365',
  'kit.x.thuLai': 'Thử lại',
  'kit.x.khop': 'Khớp',
  'kit.x.matKhau': 'Mật khẩu',
  'kit.x.hopThu': 'Hộp thư',
  'kit.x.mucNayDung': 'Mục này dựng ở bước sau (I-06c).',
  'kit.x.ketNoiO': 'Kết nối ở Quản trị › Zalo OA',
  'kit.x.mau': 'Mẫu',
  'kit.x.mocJob': 'Mốc job',
  'kit.x.duyet': 'Duyệt',
  'kit.x.gui30n': 'Gửi 30N',
  'kit.x.nhan': 'Nhận',
  'kit.x.loi': 'Lỗi',
  'kit.x.khongCoMau': 'Không có mẫu ở trạng thái này',
  'kit.x.tinDichVu': 'Tin dịch vụ · 22/Oct 09:12',
  'kit.x.suaVaGui': 'Sửa và gửi duyệt lại',
  'kit.x.xemNhatKy': 'Xem nhật ký',
  'kit.x.gio': 'Giờ',
  'kit.x.loai': 'Loại',
  'kit.x.nguoiNhan': 'Người nhận',
  'kit.x.noiDungMau': 'Nội dung / mẫu',
  'kit.x.nguoiGui': 'Người gửi',
  'kit.x.trangThai': 'Trạng thái',
  'kit.x.guiLai': 'Gửi lại',
  'kit.x.khongCoTin': 'Không có tin khớp lọc',
  'kit.x.huy': 'Huỷ',
  'kit.x.guiZaloDuyet': 'Gửi Zalo duyệt',
  'kit.x.ketNoiOa': 'Kết nối OA',
  'kit.x.caiDatKet': 'Cài đặt kết nối · Quản trị ↗',
  'kit.x.slaTraLoi': 'SLA trả lời · tháng 10',
  'kit.x.5PhutGio': '5 phút giờ làm việc · riêng Zalo OA',
  'kit.x.oiNguongO': 'Đổi ngưỡng ở Quản trị ↗',
  'kit.x.ungSla': 'Đúng SLA',
  'kit.x.tiLe': 'Tỉ lệ',
  'kit.x.hoiThoai': 'Hội thoại',
  'kit.x.qua': 'Quá',
  'kit.x.trungVi': 'Trung vị',
  'kit.x.zns14Ngay': 'ZNS 14 ngày',
  'kit.x.theoMocJob': 'Theo mốc job · tháng 10',
  'kit.x.loiGuiThang': 'Lỗi gửi · tháng 10',
  'kit.x.broadcast30Ngay': 'Broadcast · 30 ngày',
  'kit.x.con40': 'còn / 40',
  'kit.x.1LuotNgay': '+1 lượt ngày 28/Oct',
  'kit.x.chiPhiHe': 'Chi phí hệ thống ↗',
  'kit.x.chiAdminBod': 'Chỉ ADMIN / BOD',
  'kit.x.zaloTuChoi': 'Zalo từ chối ·',
  'kit.x.choZaloDuyet': 'Chờ Zalo duyệt ·',
  'kit.x.tabNayChua': 'Tab này chưa mở ở bản này',
  'kit.x.khachVaBao': 'Khách và báo giá theo ngày',
  'kit.x.khach': 'Khách',
  'kit.x.baoGia': 'Báo giá',
  'kit.x.pheuKhach': 'Phễu khách',
  'kit.x.xemChiTiet': 'Xem chi tiết',
  'kit.x.landingHieuQua': 'Landing hiệu quả',
  'kit.x.moiLanding': 'Mọi landing',
  'kit.x.nguonChinh': 'Nguồn chính',
  'kit.x.chuyenDoi': 'Chuyển đổi',
  'kit.x.canChuY': 'Cần chú ý',
  'kit.x.phieuHoiGia': 'Phiếu hỏi giá từ website · 3 mới',
  'kit.x.buildGanDay': 'Build gần đây',
  'kit.x.taoLanding': 'Tạo landing',
  'kit.x.ngonNgu': 'Ngôn ngữ',
  'kit.x.tatCa': 'Tất cả',
  'kit.x.boHetLoc': 'Bỏ hết lọc',
  'kit.x.xuatCsv': 'Xuất CSV',
  'kit.x.xinQuyen': 'Xin quyền',
  'kit.x.timTrongNhat': 'Tìm trong nhật ký',
  'kit.x.loc': 'Lọc',
  'kit.x.xoa': 'Xoá',
  'kit.x.apDung': 'Áp dụng',
  'kit.x.theoGioTrong': 'Theo giờ trong ngày',
  'kit.x.nguoi': 'Người',
  'kit.x.thietBi': 'Thiết bị',
  'kit.x.chiTiet': 'Chi tiết',
  'zalo.hei': 'Hội thoại ở HANA Hei',
  'zalo.verified': 'OA đã xác thực',
  'zalo.znsTpl': 'Mẫu ZNS',
  'zalo.znsNew': 'Mẫu ZNS mới',
  'zalo.readOnly': 'Chỉ xem',
  'zalo.composeHint': 'Soạn mẫu và gửi Zalo duyệt',
});
addMessages('en', {
  'kit.x.chuaCo': 'None yet',
  'kit.x.taiKhoanM365': 'M365 accounts',
  'kit.x.thuLai': 'Retry',
  'kit.x.khop': 'Match',
  'kit.x.matKhau': 'Password',
  'kit.x.hopThu': 'Mailbox',
  'kit.x.mucNayDung': 'This section is built in a later step (I-06c).',
  'kit.x.ketNoiO': 'Connect in Admin › Zalo OA',
  'kit.x.mau': 'Template',
  'kit.x.mocJob': 'Job milestone',
  'kit.x.duyet': 'Approval',
  'kit.x.gui30n': 'Sent 30d',
  'kit.x.nhan': 'Delivered',
  'kit.x.loi': 'Errors',
  'kit.x.khongCoMau': 'No templates in this status',
  'kit.x.tinDichVu': 'Service message · 22/Oct 09:12',
  'kit.x.suaVaGui': 'Edit and resubmit',
  'kit.x.xemNhatKy': 'View log',
  'kit.x.gio': 'Time',
  'kit.x.loai': 'Type',
  'kit.x.nguoiNhan': 'Recipient',
  'kit.x.noiDungMau': 'Content / template',
  'kit.x.nguoiGui': 'Sender',
  'kit.x.trangThai': 'Status',
  'kit.x.guiLai': 'Resend',
  'kit.x.khongCoTin': 'No messages match the filter',
  'kit.x.huy': 'Cancel',
  'kit.x.guiZaloDuyet': 'Submit to Zalo',
  'kit.x.ketNoiOa': 'OA connection',
  'kit.x.caiDatKet': 'Connection settings · Admin ↗',
  'kit.x.slaTraLoi': 'Reply SLA · October',
  'kit.x.5PhutGio': '5 working minutes · Zalo OA only',
  'kit.x.oiNguongO': 'Change threshold in Admin ↗',
  'kit.x.ungSla': 'Within SLA',
  'kit.x.tiLe': 'Rate',
  'kit.x.hoiThoai': 'Conversations',
  'kit.x.qua': 'Over',
  'kit.x.trungVi': 'Median',
  'kit.x.zns14Ngay': 'ZNS 14 days',
  'kit.x.theoMocJob': 'By job milestone · October',
  'kit.x.loiGuiThang': 'Send errors · October',
  'kit.x.broadcast30Ngay': 'Broadcast · 30 days',
  'kit.x.con40': 'left / 40',
  'kit.x.1LuotNgay': '+1 slot on 28/Oct',
  'kit.x.chiPhiHe': 'System costs ↗',
  'kit.x.chiAdminBod': 'ADMIN / BOD only',
  'kit.x.zaloTuChoi': 'Zalo rejected ·',
  'kit.x.choZaloDuyet': 'Awaiting Zalo approval ·',
  'kit.x.tabNayChua': 'This tab is not available in this version',
  'kit.x.khachVaBao': 'Customers and quotes by day',
  'kit.x.khach': 'Customers',
  'kit.x.baoGia': 'Quotes',
  'kit.x.pheuKhach': 'Customer funnel',
  'kit.x.xemChiTiet': 'View details',
  'kit.x.landingHieuQua': 'Top landing pages',
  'kit.x.moiLanding': 'All landings',
  'kit.x.nguonChinh': 'Main source',
  'kit.x.chuyenDoi': 'Conversion',
  'kit.x.canChuY': 'Needs attention',
  'kit.x.phieuHoiGia': 'Website quote requests · 3 new',
  'kit.x.buildGanDay': 'Recent builds',
  'kit.x.taoLanding': 'Create landing',
  'kit.x.ngonNgu': 'Language',
  'kit.x.tatCa': 'All',
  'kit.x.boHetLoc': 'Clear all filters',
  'kit.x.xuatCsv': 'Export CSV',
  'kit.x.xinQuyen': 'Request access',
  'kit.x.timTrongNhat': 'Search the log',
  'kit.x.loc': 'Filter',
  'kit.x.xoa': 'Clear',
  'kit.x.apDung': 'Apply',
  'kit.x.theoGioTrong': 'By hour of day',
  'kit.x.nguoi': 'User',
  'kit.x.thietBi': 'Device',
  'kit.x.chiTiet': 'Details',
  'zalo.hei': 'Conversations in HANA Hei',
  'zalo.verified': 'OA verified',
  'zalo.znsTpl': 'ZNS templates',
  'zalo.znsNew': 'New ZNS template',
  'zalo.readOnly': 'View only',
  'zalo.composeHint': 'Compose a template and submit to Zalo for approval',
});
